export const privacyData = [
  {
    id: 1,
    title: "1. Information We Collect",
    subtitle:
      "We do not collect any payment or sensitive personal data through the website. The only information we may receive includes:",
    subtitle_2: "Basic details if you contact us via email or Instagram",
    subtitle_3: "Anonymous traffic data (like how many people visit the site)",
  },
  {
    id: 2,
    title: "2. Use of Media",
    subtitle:
      "We showcase photos and videos of training sessions, matches, and players. If any parent or player wishes to have their image removed, please contact us and we’ll remove it immediately.",
  },
  {
    id: 3,
    title: "3.  Cookies",
    subtitle:
      "We may use simple cookies to track visitor count or page views. No personal data is collected or stored.",
  },
  {
    id: 4,
    title: "4. Data Sharing",
    subtitle:
      "We don’t share, sell, or trade any user data. All communication happens directly through social media or personal contact.",
  },
  {
    id: 5,
    title: "5. Changes to This Policy",
    subtitle:
      "We may update this policy if we add features (like registration forms or a login system). Please check this page for the latest version.",

  }
];
